import { TFunction } from "i18next";

export type SupportedLanguages = "en" | "es" | "fr" | "pt";

export type Internationalization = {
  t: TFunction;
  changeLanguage: (language: SupportedLanguages) => void;
  currentLanguage: SupportedLanguages;
};

export const defaultInternationalization: Internationalization = {
  t: ((key: string) => key) as unknown as TFunction,
  changeLanguage: () => undefined,
  currentLanguage: "en",
};

export const supportedLanguages: SupportedLanguages[] = ["en", "es", "fr", "pt"];
